<template>
  <div class="bg-block shadow-primaryBlock rounded
  p-8 lg:px-12 lg:py-12 mb-8 lg:mb-12" v-if="portfolios_list.data.length > 0">
    <MyInvestmentPortfoliosTitle/>
    <div v-if="portfolios_list.dirty">
      <div class="border rounded border-gray-light
                        divide-y divide-gray-light
                        overflow-hidden
                        mb-5">
        <div class="flex p-2 font-bold"
             v-for="i in 5" :key="i">
          <LoaderBlock class="h-4-5 flex-1 mr-4"/>
          <LoaderBlock class="h-4-5 flex-1"/>
        </div>
      </div>
    </div>
    <div class="-mx-2-5 lg:-mx-6">
      <MyInvestmentPortfolioItem v-for="(item,i) in portfolios_list.data"
                                 :key="i"
                                 :portfolioData="item"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import LoaderBlock from "@/components/UI/LoaderBlock";
import MyInvestmentPortfoliosTitle
  from "@/components/cabinet/Money/Dashboard/MyInvestmentPortfolios/MyInvestmentPortfoliosTitle";
import MyInvestmentPortfolioItem
  from "@/components/cabinet/Money/Dashboard/MyInvestmentPortfolios/MyInvestmentPortfolioItem/MyInvestmentPortfolioItem";

export default {
  name: "MyInvestmentPortfolios",
  components: {
    MyInvestmentPortfolioItem,
    MyInvestmentPortfoliosTitle,
    LoaderBlock
  },
  computed: {
    ...mapState('investments/portfolios', ['portfolios_list'])
  },
  methods: {
    ...mapActions('investments/portfolios', ['getPortfolios'])
  },
  mounted() {
    this.getPortfolios();
  }
}
</script>